import type { CSSProperties } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { BlockRendererMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { Preview } from "./Preview";

interface SortablePreviewProps {
  block: BaseBlock;
  components: BlockRendererMapping;
  path: string;
}

export const SortablePreview = ({
  block,
  components,
  path,
}: SortablePreviewProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: block.id });

  // TODO: Use DragOverlay instead
  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Preview
      block={block}
      components={components}
      path={path}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
    />
  );
};
